export var PayoutSortingColumn = /*#__PURE__*/ function(PayoutSortingColumn) {
    PayoutSortingColumn["PayoutNumber"] = "payoutNumber";
    PayoutSortingColumn["DepositDate"] = "depositDate";
    PayoutSortingColumn["Amount"] = "amount";
    PayoutSortingColumn["Status"] = "status";
    return PayoutSortingColumn;
}({});
export var PayoutStatusType = /*#__PURE__*/ function(PayoutStatusType) {
    PayoutStatusType["Paid"] = "paid";
    PayoutStatusType["Failed"] = "failed";
    PayoutStatusType["Deleted"] = "deleted";
    return PayoutStatusType;
}({});
export var PayoutInvoiceType = /*#__PURE__*/ function(PayoutInvoiceType) {
    PayoutInvoiceType["Payment"] = "Payment";
    PayoutInvoiceType["Refund"] = "Refund";
    PayoutInvoiceType["Dispute"] = "Dispute";
    return PayoutInvoiceType;
}({});
// --- Payout-level Integrations ---
export var PayoutIntegrationStatusValue = /*#__PURE__*/ function(PayoutIntegrationStatusValue) {
    PayoutIntegrationStatusValue["PendingSync"] = "pendingSync";
    PayoutIntegrationStatusValue["Synced"] = "synced";
    PayoutIntegrationStatusValue["SyncFailed"] = "syncFailed";
    PayoutIntegrationStatusValue["SyncInProgress"] = "syncInProgress";
    PayoutIntegrationStatusValue["Deleted"] = "deleted";
    return PayoutIntegrationStatusValue;
}({});
